import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_GET_IPO } from "../../../config/api";

export const updateIpo = createAsyncThunk(
  "ipos/update",
  async ({ id, data, navigate, setSubmitting }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "PUT",
        path: API_GET_IPO(id),
        data,
      });
      toast.success("IPO updated successfully");
      navigate && navigate(`/ipos/${id}`, { replace: true });
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      setSubmitting && setSubmitting(false);
      return rejectWithValue(error.message);
    }
  }
);
